module.exports = __webpack_public_path__ + "img/landOld.8ebaf3e9.png";